import React, { memo } from 'react';

import DescriptionList, { DescriptionListItem } from '../descriptionList/DescriptionList';

type DetailsContentProps = { content: Array<DescriptionListItem> };

const DetailsContent = memo(({ content }: DetailsContentProps): JSX.Element => <DescriptionList listItems={content} />);

export default DetailsContent;
